/*
 * @prop --vx-side-nav-background: The side-nav background.
 * @prop --vx-side-nav-content-top: The top value of the menu-content.
 * @prop --vx-side-nav-content-width: The width of the expanded side navigation.
 * @prop --vx-side-nav-item-border-color: The border color of a menu item.
 * @prop --vx-side-nav-item-hover-color: The color of a hovered menu item.
 * @prop --vx-side-nav-item-active-color: The color of a active menu item.
 */
:host {
  display: block;
  user-select: none;
  box-sizing: border-box;
}

a {
  color: currentcolor;
  text-decoration: none;
}

.menu-content {
  position: fixed;
  top: var(--vx-side-nav-content-top, 72px);
  z-index: -1;
  background: var(--vx-side-nav-background, #fff);
  overflow-y: scroll;
  transition: all 0.2s ease;
  width: var(--vx-side-nav-content-width, 85vw);
  height: var(--vx-side-nav-height);
}
.menu-content.ltr {
  transform: translateX(-100%);
}
.menu-content.rtl {
  transform: translateX(100%);
  right: 0;
}
.menu-content.btt {
  transform: translateY(100%);
}
.menu-content.ttb {
  transform: translateY(-200%);
}
.menu-content ul {
  list-style: none;
  margin: 0;
  padding: 0 8px;
}
.menu-content ul li a {
  padding: 0 16px;
  display: flex;
  height: 48px;
  align-items: center;
  color: currentcolor;
  text-decoration: none;
  border-bottom: 1px solid var(--vx-side-nav-item-border-color, #ddd);
  justify-content: space-between;
}
.menu-content ul li a::after {
  transition: all 0.2s ease-in;
  right: 16px;
  align-self: center;
  font-family: "Material Icons", serif;
  font-size: 1.6em;
}
.menu-content ul li a:hover {
  background-color: var(--vx-side-nav-item-hover-color, #e9e9e9);
}
.menu-content ul li.has-children > a::after {
  content: "\e5cc";
}
.menu-content ul li.open a {
  border-bottom: 1px solid var(--vx-side-nav-item-border-color, #ddd);
}
.menu-content ul li.open > a::after {
  transform: rotate(90deg);
}
.menu-content ul li.active:not(.has-children) > a {
  color: var(--vx-side-nav-item-active-color, var(--mdc-theme-accent, #000));
}
.menu-content ul li li {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
.menu-content ul li li a::after {
  opacity: 0;
}
.menu-content ul li.open > ul > li {
  max-height: 500px;
  transition: max-height 0.2s ease-in;
}
.menu-content ul li.open > ul > li.collapsable a::after {
  opacity: 1;
}

.overlay {
  background-color: var(--overlay-background, rgba(209, 207, 207, 0.6));
  transition: opacity 0.2s ease-in;
  position: fixed;
  z-index: -1;
  opacity: 0;
  width: 100%;
  height: 100vh;
  display: none;
}

.open .menu-content {
  transform: translateY(0) translateX(0);
}
.open .overlay {
  opacity: 1;
  display: block;
}